import type { Permissions } from "@KassaroAB/shared/types/enums/Permissions";
import type { PermissionGroupId, StoreId } from "@KassaroAB/shared/types/ids";
import { api } from "../utils/api";

export const getStorePermissionsApi = (
  storeId: StoreId,
): Promise<{
  permissionGroup: PermissionGroupId | null;
  permissions: Permissions[];
}> => {
  return api.get(`stores/${storeId}/permissions`);
};
